<ng-container *ngIf="likesCount && lastLikedUser; else noLikes">
  <app-user-avatar 
    *ngIf="!isComments" 
    [user]="lastLikedUser" 
    [size]="24" 
    icon="heart-small"
  ></app-user-avatar>
  <img *ngIf="isComments" [src]="'heart-small' | iconByName"/>
  <span 
    [class]="isComments ? 'p5' : 'p4'" 
    (click)="onLabelClick()"
    [ngStyle]="{'cursor': isAdmin ? 'pointer' : 'inherit'}"
  >{{nameAndCounter}}</span>
  
  <app-adaptive-modal title="Likes" [showModal]="openLikesList">
    <ng-container *ngIf="showModal | async">
      <div class="list-item_block" *ngIf="likesList$ | async as likesList; else loader">
        <span *ngIf="!likesList?.length" class="p1 placeholder">No likes yet</span>

        <div class="list-item" *ngFor="let user of likesList">
          <app-user-avatar [size]="48" [user]="user"></app-user-avatar>
          <div class="list-item_info">
            <span class="title" (click)="openUrl('/user-profile/user/' + user.id)">{{ user?.userName || '...' }}</span>
            <span class="p6 grey-text">{{ user.firstName }} {{ user.lastName }}</span>
          </div> 
        </div>
      </div>
    </ng-container>

    <ng-template #loader>
      <app-spinner class="list-loader"></app-spinner>
    </ng-template>
  </app-adaptive-modal>
</ng-container>

<ng-template #noLikes>
  <span *ngIf="!isComments" class="p5">No likes yet</span>
</ng-template>